import { css } from '@emotion/css';
import { Y100 } from '../Colors';

export const backgroundNavbar = css`
  background-color: ${Y100};
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;

  .nav-link {
    align-self: center;
  }

  .nav-item {
    align-self: center;
  }

  .welcome {
    max-width: 250px;
    text-align: center;
    margin: auto;
  }

  .nav-link {
    padding-left: 2rem !important;
  }
`;
